function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 4284",
    style: {
      opacity: 0.78,
      clipPath: "url(#rb38d8p5va)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "\\uD0C0\\uC6D0 85",
    cx: 105,
    cy: 111,
    rx: 105,
    ry: 111,
    transform: "translate(118 900)",
    style: {
      fill: "#1cb691",
      opacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "\\uD0C0\\uC6D0 84",
    cx: 145,
    cy: 153,
    rx: 145,
    ry: 153,
    transform: "translate(-67 969)",
    style: {
      fill: "#e0ff8d",
      opacity: 0.37
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.61fe5e7d731a578877a6ffb3629b7b60.svg";
export { ForwardRef as ReactComponent };